(() => {
  'use strict';
  if (customElements.get('fy-uk-hs-gift')) return;
  customElements.define('fy-uk-hs-gift', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.catalogObservers = [];
      this.resizeObserver = null;
      this.layoutFrame = 0;
      const source = this.querySelector('[data-gift-variants]');
      if (!source) return;
      try { this.data = JSON.parse(source.textContent); }
      catch { console.warn('FITUEYES gift variant data could not be read.'); return; }
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-gift-variant]');
        if (!button || !this.contains(button)) return;
        const variant = this.data.variants.find(item => item.id === button.dataset.giftVariant);
        if (!variant) return;
        this.querySelectorAll('[data-gift-variant]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelectorAll('[data-gift-color]').forEach(item => { item.textContent = variant.name; });
        const image = this.querySelector('[data-gift-image]');
        if (variant.image) image.src = variant.image;
        image.alt = `${this.data.productLabel} in ${variant.name} with LED ambient lighting`;
        this.querySelector('[data-gift-price]').textContent = variant.price;
        const compare = this.querySelector('[data-gift-compare-price]');
        compare.hidden = !variant.comparePrice;
        compare.textContent = variant.comparePrice || '';
        const stock = this.querySelector('[data-gift-stock]');
        stock.hidden = !variant.soldOut;
        stock.textContent = variant.soldOut ? this.data.soldOutText : '';
        this.querySelector('[data-gift-product-link]').href = variant.url;
      }, { signal: this.controller.signal });

      this.catalogs = [...document.querySelectorAll('fy-uk-hs-module.fy-uk-halloween-scene[data-kind="catalog"]')];
      this.catalogs.forEach(catalog => {
        const observer = new MutationObserver(() => this.scheduleCatalogLayout());
        observer.observe(catalog, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
        this.catalogObservers.push(observer);
        catalog.querySelector('.category-tabs')?.addEventListener('click', () => this.scheduleCatalogLayout(), { signal: this.controller.signal });
      });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.scheduleCatalogLayout());
        this.catalogs.forEach(catalog => this.resizeObserver.observe(catalog));
      }
      window.addEventListener('resize', () => this.scheduleCatalogLayout(), { passive: true, signal: this.controller.signal });
      this.scheduleCatalogLayout();
      if (document.fonts?.ready) document.fonts.ready.then(() => this.scheduleCatalogLayout());
    }

    scheduleCatalogLayout() {
      if (this.layoutFrame) cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = requestAnimationFrame(() => {
        this.layoutFrame = requestAnimationFrame(() => {
          this.catalogs?.forEach(catalog => {
            catalog.querySelectorAll('[data-category-panel]:not([hidden])').forEach(panel => {
              const titles = [...panel.querySelectorAll('.product-card__title')];
              if (!titles.length) return;
              panel.style.setProperty('--catalog-title-height', '0px');
              const maxTitleHeight = Math.ceil(Math.max(...titles.map(title => title.getBoundingClientRect().height)));
              panel.style.setProperty('--catalog-title-height', `${maxTitleHeight}px`);
            });
          });
          this.layoutFrame = 0;
        });
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.catalogObservers?.forEach(observer => observer.disconnect());
      this.resizeObserver?.disconnect();
      if (this.layoutFrame) cancelAnimationFrame(this.layoutFrame);
      this.controller = null;
      this.catalogObservers = [];
      this.resizeObserver = null;
      this.catalogs = [];
      this.layoutFrame = 0;
    }
  });
})();
